import { ShipmentReference } from "./ShipmentReference";

export class ShipmentReferences { 
    ShipmentReference: ShipmentReference;  
}